import type { ComponentPropsWithRef } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { Button } from '../Button/Button';
import { Card } from '../Card/Card';
import { Illustration } from '../Illustration/Illustration';
import { ExternalLink } from '../Link/ExternalLink';
import { Text } from '../Text/Text';
import { Title } from '../Title/Title';
import { containerStyle, contentWrapperStyle, illustrationStyle, messageStyle } from './ErrorState.css';

type Props = ComponentPropsWithRef<'div'> & {
  onRetry?: () => void;
  title: string;
};

export const ErrorState = ({ onRetry, title, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <Card.Root {...delegated} className={clsx(containerStyle, delegated.className)}>
      <Illustration className={illustrationStyle} name="Error" strokeWidth={1.8} />

      <div className={contentWrapperStyle}>
        <div className={messageStyle}>
          <Title as="h2">{title}</Title>

          <Text>
            <Trans components={{ email: <ExternalLink /> }} i18nKey="common:errors.contactSupport" />
          </Text>
        </div>

        {onRetry && (
          <Button emphasis="secondary" icon="Sync" onClick={onRetry}>
            {t('common:actions.retry')}
          </Button>
        )}
      </div>
    </Card.Root>
  );
};
